import React from "react";
import { formatDateTime } from "../../../utils/dateTime";
import { ACTIVITY_META } from "./evaluationUtils";

/** Section scores (score / weight), total / 100 and the band. */
export const ScorePanel = ({ scores, saving }) => {
  if (!scores) {
    return (
      <div className="eval-card eval-score">
        <div className="approval-meta-label">Score</div>
        <p className="fs-085 text-slate-500 mb-0">No ratings yet.</p>
      </div>
    );
  }
  return (
    <div className="eval-card eval-score" aria-live="polite">
      <div className="d-flex justify-content-between align-items-start">
        <div>
          <div className="approval-meta-label">Total score</div>
          <div className="eval-total tabular-nums">
            {scores.total}
            <span className="eval-total-max"> / 100</span>
          </div>
        </div>
        {saving && (
          <span
            className="spinner-border spinner-border-sm text-primary"
            role="status"
            aria-label="Updating score"
          ></span>
        )}
      </div>
      <div className="d-flex flex-wrap gap-2 align-items-center mt-1">
        {scores.band ? (
          <span className="preview-band">{scores.band}</span>
        ) : (
          <span className="preview-band preview-band--none">No band</span>
        )}
        {!scores.complete && (
          <span className="status-pill status-pill--amber">Incomplete</span>
        )}
      </div>
      <ul className="eval-score-list">
        {scores.sections.map((s) => (
          <li key={s.key}>
            <span className="text-truncate">{s.title}</span>
            <span className="tabular-nums text-nowrap">
              <strong>{s.score}</strong> / {s.weight}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

/** Activity history, oldest first, with the actor's name from the API. */
export const ActivityTimeline = ({ activities = [] }) => (
  <div className="eval-card">
    <h3 className="eval-section-title mb-3">History</h3>
    {activities.length === 0 ? (
      <p className="fs-085 text-slate-500 mb-0">No activity yet.</p>
    ) : (
      <ol className="eval-timeline">
        {activities.map((a) => {
          const meta = ACTIVITY_META[a.action] || {
            label: a.action,
            icon: "bi-dot",
            tone: "gray",
          };
          return (
            <li
              key={a.id}
              className={`eval-timeline-item eval-timeline-item--${meta.tone}`}
            >
              <i className={`bi ${meta.icon}`} aria-hidden="true"></i>
              <div>
                <div className="fs-085">
                  <strong>{meta.label}</strong>
                  {a.stepLabel && <span> · {a.stepLabel}</span>}
                </div>
                <div className="text-slate-500 fs-075">
                  {a.actorName || "Unknown user"} ·{" "}
                  {formatDateTime(a.createdAt)}
                </div>
                {a.remarks && (
                  <div
                    className={`approval-note mt-1 ${a.action === "RETURNED" || a.action === "CANCELLED" ? "approval-note--rejected" : ""}`}
                  >
                    {a.remarks}
                  </div>
                )}
              </div>
            </li>
          );
        })}
      </ol>
    )}
  </div>
);
